export const EmptyData = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-4 p-6 border rounded border-gray-E6E6E3">
      <div className="text-base text-gray-333 text-center">{children}</div>
    </div>
  )
}
